import { configureStore } from '@reduxjs/toolkit';
import entityCardSlice from './slices/entityCardSlice';
import customQueryBodySlice from './slices/customQueryBodySlice';
import operationsSlice from './slices/OperationsCardSlice';
import customQuerySlice from './slices/customQuerySlice';
import customQueryHeaderSlice from './slices/customQueryHeaderSlice';
import queriesManagerSlice from './slices/QueriesManagerSlice';
import thunk from 'redux-thunk';
export default configureStore({
  reducer: {
    entityCard: entityCardSlice,
    customQueryBody: customQueryBodySlice,
    operations: operationsSlice,
    customQuery: customQuerySlice,
    customQueryHeader: customQueryHeaderSlice,
    queriesManager: queriesManagerSlice
  },
  middleware: [thunk]
});